import React from 'react';
import { Route, Switch } from 'react-router';
import ClientEmails from 'bigmailer/ClientEmails.component';
import ClientEmailsSplash from 'bigmailer/ClientEmailsSplash.component';
import EmailAnalytics from 'bigmailer/EmailAnalytics.component';
import cn from 'classnames';

import CommunicationsHeader from 'components/comms/CommunicationsHeader.component';
import SidebarMenu from 'components/menu/SidebarMenu.component';
import LINK from 'constants/link.const';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { withTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import CampaignsLayout from 'clientCommunications/components/Campaigns/CampaignsLayout';
import ClientConnectLayout from 'clientCommunications/components/ClientConnect/ClientConnectLayout';
import ClientsLayout from 'clientCommunications/components/Clients/ClientsLayout';
import MarketingLayout from 'clientCommunications/components/Marketing/MarketingLayout';
import RemindersLayout from 'clientCommunications/components/Reminders/RemindersLayout.component';
import TopNav from 'common/TopNav.component';
import ExactDuplicatesLayout from 'mergeClients/components/ExactDuplicates/ExactDuplicatesLayout';

import CN from './ClientCommunicationsRoutes.module.scss';

const ClientCommunicationsRoutes = ({ isDarkMode }) => {
  const salonId = useCurrentSalonId();
  const { t } = useTranslation();

  const marketing = linkTo({ pattern: LINK.marketing, params: { salonId }, fault: '#' });
  const campaigns = linkTo({ pattern: LINK.campaigns, params: { salonId }, fault: '#' });
  const clientConnect = linkTo({ pattern: LINK.clientConnect, params: { salonId }, fault: '#' });
  const mergeClients = linkTo({ pattern: LINK.mergeClients, params: { salonId }, fault: '#' });

  const reminders = linkTo({ pattern: LINK.reminders, params: { salonId }, fault: '#' });
  const emails = linkTo({ pattern: LINK.emails, params: { salonId }, fault: '#' });
  const emailsLinkSplash = linkTo({ pattern: LINK.emailsSplash, params: { salonId }, fault: '#' });
  const emailsAnalytics = linkTo({ pattern: LINK.emailsSent, params: { salonId }, fault: '#' });

  return (
    <div
      data-bem="ClientCommunicationsRoutes"
      className={cn({
        'page-content marketing': true, // FIXME: remove after refactoring page summary
        'dark-class': isDarkMode,
        [CN.component]: true,
      })}
    >
      <TopNav title={t('marketing.sectionTitle')}>
        <SidebarMenu />
      </TopNav>

      <CommunicationsHeader bucketType="list" />

      <Switch>
        <Route path={marketing} component={MarketingLayout} />
        <Route path="/salon/:id/communications/clients/:bucketType" component={ClientsLayout} /> {/* TODO: */}
        <Route path={campaigns} component={CampaignsLayout} />
        <Route path={clientConnect} component={ClientConnectLayout} />
        <Route path={mergeClients} component={ExactDuplicatesLayout} />
        <Route path={reminders} component={RemindersLayout} />
        <Route path={emails} component={ClientEmails} />
        <Route path={emailsLinkSplash} component={ClientEmailsSplash} />
        <Route path={emailsAnalytics} component={EmailAnalytics} />
      </Switch>
    </div>
  );
};

const ClientCommunicationsRoutesHoc = withTheme()(ClientCommunicationsRoutes);

export default ClientCommunicationsRoutesHoc;
